import React,{ Component } from "react";
import { injectIntl } from 'react-intl';
import { Keyboard, ScreenShare, Add } from "@material-ui/icons";
import { formatMessage, MainMenuContribution, withModulesManager } from "@openimis/fe-core";


class BanksMainMenu extends Component {
    render() {
        const { intl } = this.props;
        let entries = [];
        // entries.push({
        //     text: formatMessage(intl, "banks", "menu.my_entities"),
        //     icon: <Keyboard />,
        //     route: "/banks/my_entities"
        // });
        // entries.push({
        //     text: formatMessage(intl, "banks","menu.add_bank" ),
        //     icon: <Add />,
        //     route: "/banks/add_bank"
        // })

        if (!entries.length) return null;
        return (
            <MainMenuContribution
                {...this.props}
                header= {formatMessage(intl, "banks", "mainMenu")}
                icon={<ScreenShare />}
                entries={entries}
            />
        );
    }
}

export default withModulesManager(injectIntl(BanksMainMenu));